// API設定
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://z7pvme24ig.execute-api.ap-northeast-1.amazonaws.com';

export const API_ENDPOINTS = {
  companies: '/companies',
  company: (name: string) => `/company/${encodeURIComponent(name)}`,
  companyByCode: (securityCode: string) => `/company-by-code/${securityCode}`, // 証券コードで直接企業データ取得
  search: (query: string) => `/search?q=${encodeURIComponent(query)}`,
  compare: (names: string[]) => `/compare?ids=${names.map(name => encodeURIComponent(name)).join(',')}`
};

// Cognito設定
const CONFIG = {
  API_BASE_URL: API_BASE_URL,
  COGNITO: {
    USER_POOL_ID: 'ap-northeast-1_9MWZnsPtw',
    CLIENT_ID: '1fk5efv1kfdovd9id2g8u7ls8k',
    REGION: 'ap-northeast-1'
  }
};

export default CONFIG;
